




























































import useImageGalleryModal from "@/composables/v3/useImageGalleryModal";
import i18n from "@/libs/i18n";
import { useChannelsStore } from "@/store/useChannelsStore";
import { displayFileName, downloadFile, getFullPath } from "@/utils/assets";
import { textIsOnlyEmoji } from "@/utils/v3/chat.utils";
import ParsedMessage from "@/views/modules/messaging-inbox/chat-log-entries/parsedMessage.vue";
import { Asset, AttachmentEntryDto } from "@saysimple-platform/dtos";
import { computed, defineComponent, ref, Ref, SetupContext } from "@vue/composition-api";
import { onKeyStroke } from "@vueuse/core";
import { BButton, BCarousel, BCarouselSlide, BImgLazy, BModal } from "bootstrap-vue";
import imageZoom from "vue-image-zoomer";
import { useToast } from "vue-toastification/composition";

export default defineComponent({
    components: {
        BButton,
        BCarousel,
        BCarouselSlide,
        BImgLazy,
        BModal,
        ParsedMessage,
        imageZoom,
    },
    // Bit hacky to type define it like this, but better than TS ignores, because TS cannot resolve props from an refs out of the box.
    setup(_, ctx: SetupContext & { refs: { carousel } }) {
        const carousel: Ref<HTMLElement> = ref(null);

        const channelsStore = useChannelsStore();
        const { imageGallerySlideIndex, attachmentEntries, images, openImageGalleryModal, showImageGalleryModal } =
            useImageGalleryModal();

        // Done this here with VueUse, so no matter on what element the focus is.
        // This won't trigger as long as the modal is not visible (showImageGalleryModal is false), so not conflicting wherever you trigger the key stroke.
        onKeyStroke(
            ["ArrowLeft", "ArrowRight"],
            (keyEvent) => {
                if (keyEvent.key === "ArrowLeft") {
                    ctx.refs.carousel.prev();
                } else if (keyEvent.key === "ArrowRight") {
                    ctx.refs.carousel.next();
                }
            },
            { dedupe: true }
        );

        //----------------------------------------------------------------------

        const activeAttachmentEntry = computed(
            (): AttachmentEntryDto => attachmentEntries.value.find((entry) => entry.id === activeImage.value?.entryId)
        );

        // Assumption that the slide index of the carousel is the same order as the images array. Should be okay.
        const activeImage = computed((): Asset & { entryId: number } => images.value[imageGallerySlideIndex.value]); // Every attachment entry can have one or multiple assets.

        //----------------------------------------------------------------------

        const isOnlyEmoji = computed((): boolean => textIsOnlyEmoji(activeAttachmentEntry.value.message));

        const toast = useToast();
        const localDownloadFile = (image: Record<string, string> | Asset) => {
            downloadFile(image).catch(() => toast.error(i18n.t("toast.read.error")));
        };

        return {
            activeAttachmentEntry,
            activeImage,
            attachmentEntries,
            channelsStore,
            displayFileName,
            getFullPath,
            imageGallerySlideIndex,
            images,
            isOnlyEmoji,
            localDownloadFile,
            openImageGalleryModal,
            showImageGalleryModal,
            carousel,
        };
    },
});
